











import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
@Component
export default class Result extends Vue {
  downLoadUrl: string =
    'https://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  pointOut = false;
  goHome() {
    this.$router.push('home');
  }
  download() {
    this.$dialog
      .confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
      .then((action) => {
        console.log(action);
        window.location.href = this.downLoadUrl;
      })
      .catch((action) => {
        console.log(action);
        if (action === 'overlay') {
          // 忽略掉点击遮罩层的关闭行为
          return;
        }
        if (isWeiXin()) {
          this.pointOut = true;
        } else {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        }
      });
  }
}
